import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const HelpCenterOutline = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M12.109 2C6.917 2 2 6.917 2 12.109c0 1.864 1.03 4.402 2.63 5.946 0 0-1.166 1.36-1.612 1.921-.526.675.011 1.11.903 1.292 1.247.263 3.865.95 8.085.664 5.717-.378 10.2-4.643 10.2-9.835C22.218 6.917 17.3 2 12.109 2Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <Path
      d="m15.04 9.911-.001-.033a2.964 2.964 0 0 0-2.96-2.927 2.964 2.964 0 0 0-2.96 2.96.79.79 0 1 0 1.578 0 1.383 1.383 0 1 1 1.923 1.272 2.202 2.202 0 0 0-1.33 2.033v.05a.79.79 0 0 0 1.578 0v-.05c0-.256.146-.484.373-.58A2.958 2.958 0 0 0 15.04 9.91Z"
      fill="currentColor"
    />
    <Path
      d="M13.05 16.422a.971.971 0 1 1-1.942 0 .971.971 0 0 1 1.942 0Z"
      fill="currentColor"
      strokeWidth={0.058}
    />
  </Icon>
);

export default HelpCenterOutline;
